import { MedRecSwitch, SearchHeaderInline, StoreLocator } from '@/components';
import {
  HeaderBurgerNav,
  HeaderFavorites,
  HeaderLogo,
  HeaderNav,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

import styles from './withHorizontalNav.module.scss';

const HeaderWithHorizontalNavMobile = () => (
  <>
    <HeaderRow borderless type="small">
      <HeaderSection justify="start">
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless type="small-bottom">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow relativePosition type="flat" withNavbar>
      <HeaderSection className={styles.horizontal_nav__section} justify="start">
        <HeaderBurgerNav />
        <div className={styles.horizontal_nav__wrapper} data-search-nav-slot>
          <SearchHeaderInline className={styles.search__header_inline} />
          <HeaderNav viewport="mobile" />
        </div>
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithHorizontalNavMobile };
